// extracted by mini-css-extract-plugin
module.exports = {"container":"FixedButtons_container__OK8MN","button":"FixedButtons_button__2w0f2","email":"FixedButtons_email__1Ba3I","tutorial":"FixedButtons_tutorial__3g2nv"};